import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  transition: all 0.3s ease;

  &:not(:first-child) {
    border-top: 1px solid #a7a7a780;
  }

  &[data-is-open='true'] {
    background-color: ${({ theme }) => (theme.isDark ? '#1b1b1b' : '#f3f3f3')};
  }
`

export const TimeIcons = styled.div`
  color: ${({ theme }) => (theme.isDark ? '#CFCFCF' : ' #393939')};
  font-size: 10px;
  font-style: normal;
  font-weight: 600;

  &[data-type='chapter'] {
    font-weight: 500;
  }

  display: flex;
  gap: 16px;

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
`

export const Button = styled.button`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  padding: 22px 14px 14px 30px;

  background: none;
  border: 0;

  &[data-is-active='true'] {
    border-left: 3px rgb(${({ theme }) => theme.primary.base}) solid;

    .group {
      .title {
        color: rgb(${({ theme }) => theme.primary.base});
      }
    }
  }

  &[data-is-open='true'] {
    .arrow {
      transform: rotate(-180deg);
      color: rgb(${({ theme }) => theme.primary.base});
    }
  }

  &[data-has-no-chapters='true'] {
    .checked,
    .unchecked,
    .group .title {
      opacity: ${({ theme }) => (theme.isDark ? 0.2 : 0.4)};
    }

    cursor: not-allowed;
  }

  .checked,
  .unchecked {
    flex-shrink: 0;

    width: 15px;
    height: 15px;

    margin-top: 2px;
    margin-right: 8px;
  }

  .checked {
    --check-color: ${({ theme }) => (theme.isDark ? '#222222' : '#fff')};
    --background-color: ${({ theme }) => (theme.isDark ? '#4DFD3C' : '#0bc196')};
  }

  .unchecked {
    color: #a7a7a7;
  }

  .group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 6px;

    max-width: 246px;

    .title {
      display: flex;
      align-items: flex-start;
      gap: 4px;

      color: ${({ theme }) => (theme.isDark ? '#fff' : '#4a4a4a')};
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 17px;

      text-align: start;

      .name {
        word-break: break-word;
      }
    }

    .empty-info {
      color: ${({ theme }) => (theme.isDark ? '#CFCFCF' : '#393939')};

      font-size: 10px;
      font-style: normal;
      font-weight: 600;
      line-height: 17px;
    }
  }

  .arrow {
    width: 20px;
    height: 20px;

    color: #4b4b4b;

    flex-shrink: 0;

    margin-left: auto;

    transition: all 0.3s ease;
  }
`

export const Expandable = styled.div<{ $height: number }>`
  max-height: 0;
  overflow: hidden;

  padding: 0 20px 0 48px;

  transition: max-height 0.3s ease;

  &[data-is-open='true'] {
    max-height: ${({ $height }) => $height}px;
  }
`

export const Chapter = styled(Link)`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  padding: 10px 14px 14px;

  border: 0;
  border-radius: 4px;

  margin-bottom: 6px;

  &[data-is-active='true'] {
    background-color: ${({ theme }) => (theme.isDark ? '#0D0D0D' : '#fff')};

    border-left: 3px rgb(${({ theme }) => theme.primary.base}) solid;
    border-radius: 0 4px 4px 0;
  }

  &[data-disabled='true'] {
    cursor: not-allowed;

    .checked,
    .unchecked,
    .group .title {
      opacity: ${({ theme }) => (theme.isDark ? 0.3 : 0.4)};
    }
  }

  &:last-child {
    margin-bottom: 12px;
  }

  .checked,
  .unchecked {
    flex-shrink: 0;

    width: 15px;
    height: 15px;

    margin-top: 2px;
    margin-right: 14px;
  }

  .checked {
    --check-color: ${({ theme }) => (theme.isDark ? '#222222' : '#fff')};
    --background-color: ${({ theme }) => (theme.isDark ? '#4DFD3C' : '#0bc196')};
  }

  .unchecked {
    color: #a7a7a7;
  }

  .group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    gap: 6px;

    .title {
      display: flex;
      align-items: flex-start;
      gap: 4px;

      color: ${({ theme }) => (theme.isDark ? '#fff' : '#4a4a4a')};

      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 17px;

      text-align: start;

      word-break: break-word;
    }

    .empty-info {
      color: ${({ theme }) => (theme.isDark ? '#CFCFCF' : '#393939')};

      font-size: 10px;
      font-style: normal;
      font-weight: 600;
      line-height: 17px;
    }
  }
`
